import {
    competitiveResearch,
    marketResearch,
    searchIntelligence,
    adIntelligence,
    genAIIntelligence,
} from "app/components/sidebar3/dynamic-config/configs/sidebar31/list-items/listItems";
import { isAfterTrialDigitalSuiteHomeSidebarVisible } from "app/components/sidebar3/primary-side-bar/afterTrialDigitalSuiteHome/utils";
import {
    dashboard,
    whatsNew,
    similarwebExtention,
    premiumFeatures,
    userSettings,
    activationHome,
    getAfterTrialDigitalSuiteHomeSidebarItem,
} from "app/components/sidebar3/SideBarItems";
import type { IPrimarySidebarItem } from "app/components/sidebar3/types";

export const getItemsList = (): IPrimarySidebarItem[] => {
    const showAfterTrialDigitalSuiteHome = isAfterTrialDigitalSuiteHomeSidebarVisible();

    const activationHomeWithExperimentOverride: IPrimarySidebarItem = {
        ...activationHome,
        isHidden: activationHome.isHidden || showAfterTrialDigitalSuiteHome,
    };

    const items: IPrimarySidebarItem[] = [
        getAfterTrialDigitalSuiteHomeSidebarItem(showAfterTrialDigitalSuiteHome),
        activationHomeWithExperimentOverride,
        dashboard,
        competitiveResearch,
        searchIntelligence,
        genAIIntelligence,
        adIntelligence,
        marketResearch,
        premiumFeatures,
        whatsNew,
        similarwebExtention,
        userSettings,
    ];
    return items;
};
